import FlexBox from '../FlexBox'

import type { ReactNode } from 'react'
import type { FlexBoxProps } from '../FlexBox/FlexBox'

interface Props extends FlexBoxProps {
  children?: ReactNode | ReactNode[] | React.ReactElement | React.ReactElement[]
}

const FlexCol = ({ children, ...props }: Props) => (
  <FlexBox col {...props}>
    {children}
  </FlexBox>
)

export default FlexCol
